import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import React, { useState } from 'react';
import { getApiUrl } from 'api/helpers';
import { ApiRoutes } from 'types';
import { IconButton, ListItemText, Menu, MenuItem } from '@mui/material';
import { MoreVert } from '@mui/icons-material';

export const UsersListActionsCell = ({ cellProps }: { cellProps: GridRenderCellParams }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleImpersonate = () => {
    const userId = cellProps.row.id;
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = getApiUrl({ path: ApiRoutes.Impersonate });

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'userId';
    input.value = userId;

    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  };

  return (
    <>
      <IconButton size="small" onClick={handleClick}>
        <MoreVert />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleImpersonate}>
          <ListItemText primary="Impersonate" />
        </MenuItem>
      </Menu>
    </>
  );
};
